

import { PlayerApi } from '../../communication/player-api/PlayerApi'
import {PlayerItemList, PlayerItemView} from '../../communication/PlayerApiProtocol.generated'
import {getStore, ApplicationState} from '../Store'
import {ReduxAction, hasExpired} from '../ReduxUtils'
export const REQUEST_ITEMS = 'REQUEST_ITEMS'
export const RECEIVE_ITEMS = 'RECEIVE_ITEMS'
export const ITEMS_ERROR = 'ITEMS_ERROR'
export const TOGGLE_ITEM = 'TOGGLE_ITEM'



export const fetchItems = (force? : boolean) => getStore().dispatch(_fetchItems(force) as any)

function _fetchItems(force? : boolean) {
	return (dispatch, getState : () => ApplicationState) => {

		if (!hasExpired(force, getState().player.itemState, 60)){
			return
		}
		dispatch(requestItems())

		PlayerApi.requestItems((itemList : PlayerItemList) => {
			dispatch(receiveItems(itemList.items))
		},()=>{
			dispatch(itemsError())
		})
	}
}

export function toggleItem(itemId : string) {
	return {
		type : TOGGLE_ITEM,
		payload : itemId,
		createdTime : Date.now()
	}
}

function itemsError() : ReduxAction<{}> {
	return {
		type: ITEMS_ERROR,
		payload: {},
		createdTime : Date.now()
	}
}
function requestItems() : ReduxAction<{}> {
	return {
		type: REQUEST_ITEMS,
		payload: {},
		createdTime : Date.now()
	}
}

function receiveItems(items : PlayerItemView[]) : ReduxAction<PlayerItemView[]> {
	return {
		type: RECEIVE_ITEMS,
		payload: items,
		createdTime : Date.now()
	}
}

